module.exports = __webpack_public_path__ + "img/more-goods.6cb62c9e.png";